import { useMutation } from '@tanstack/react-query';
import { fetchData } from 'gql/graphql-fetcher';
import { useQueryInvalidator } from '@utils/useQueryInvalidator';
import { useCurrentProject } from '@modules/projects/utils/useCurrentProject';
import { useBudgetItemsQuery } from 'gql/index';

type AddQuoteInput = {
  projectId: number;
  name: string;
  amount: number;
  quoteDate: string;
  costItemId: number;
};

type EditQuoteInput = AddQuoteInput & { id: number };

const addQuoteDocument = `
  mutation addQuote($input: AddQuoteInput!) {
    addQuote(input: $input) {
      quote {
        id
      }
      errors { ... on Error { message } }
    }
  }
`;

const editQuoteDocument = `
  mutation editQuote($input: EditQuoteInput!) {
    editQuote(input: $input) {
      quote { id }
      errors { ... on Error { message } }
    }
  }
`;

export const useQuoteMutations = () => {
  const { projectId } = useCurrentProject();
  const invalidate = useQueryInvalidator();

  const addQuote = useMutation({
    mutationKey: ['addQuote'],
    mutationFn: (variables: { input: AddQuoteInput }) =>
      fetchData(addQuoteDocument, variables)(),
    onSuccess: () => {
      invalidate(useBudgetItemsQuery, { projectId });
    },
  });

  const editQuote = useMutation({
    mutationKey: ['editQuote'],
    mutationFn: (variables: { input: EditQuoteInput }) =>
      fetchData(editQuoteDocument, variables)(),
    onSuccess: () => {
      invalidate(useBudgetItemsQuery, { projectId });
    },
  });

  return { addQuote, editQuote };
};
